exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2-QaCQxVvqN-0e{margin:0 10px}.ez2gM9rCWsf62p{padding:5px;color:#97a0af}._2l3HkcQgyLjUZX{margin-top:10px}", ""]);

// exports
exports.locals = {
	"form": "_2-QaCQxVvqN-0e",
	"grayText": "ez2gM9rCWsf62p",
	"noPasswordFooter": "_2l3HkcQgyLjUZX"
};